// import { Message } from 'element-ui';
import NProgress from 'nprogress'; // progress bar
import router from './router';
// import store from './store';

import 'nprogress/nprogress.css'; // progress bar style

NProgress.configure({ showSpinner: false }); // NProgress Configuration

router.beforeEach(async (to, from, next) => {
  if (to.meta && to.meta.pageTitle) {
    document.title = to.meta.pageTitle;
  }
  if (to.path !== '/login' && to.path !== '/forgetPwd') {
    // 判断是否已经登录
    if (window.localStorage.getItem('LOGIN_INFO')) {
      next();
    } else {
      next({ path: '/login' });
    }
  } else {
    next();
  }
});

router.afterEach(() => {
  // finish progress bar
  NProgress.done();
});
